import _Vue from 'vue'
import store from '@/store'
import { Services } from '@/utils/services.enum'

export enum Roles {
  ADMIN = 'ADMIN',
  AGENT = 'AGENT',
  EMPLOYEE = 'EMPLOYEE',
  WHOLESALER = 'WHOLESALER',
  ACCOUNTANT = 'ACCOUNTANT',
}

const hasService = (service: Services): boolean => {
  const user = store.state.profile
  if (user) {
    return user.services.includes(service)
  }
  return false
}

export default {
  install: (Vue: typeof _Vue) => {
    Vue.prototype.$s = {
      get hasRemittance(): boolean {
        return hasService(Services.Remittance)
      },
      get hasTopUp(): boolean {
        return hasService(Services.Topup)
      },
      get hasNauta(): boolean {
        return hasService(Services.Nauta)
      },
      get hasMessage(): boolean {
        return hasService(Services.Sms)
      },
      get hasDelivery(): boolean {
        return hasService(Services.Delivery)
      },
    }
  },
}

declare module 'vue/types/vue' {
  interface Vue {
    $s: {
      hasRemittance: boolean
      hasTopUp: boolean
      hasNauta: boolean
      hasMessage: boolean
      hasDelivery: boolean
    }
  }
}
